import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=d4aefe98&"
import script from "./customButton.vue?vue&type=script&lang=js&"
export * from "./customButton.vue?vue&type=script&lang=js&"
import style0 from "./customButton.vue?vue&type=style&index=0&id=d4aefe98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports